import { useCallback } from "react";

import { Rewrite } from "@/types/customTypes";
import { Params, useParams } from "@/hooks/useParams";
import { doIt } from "@/utils/doIt";

//

type UseRedirectUrlReturn<T> = Rewrite<
  Params<"redirect_url" | (string & {})>,
  {
    getRedirectUrl: () => T;
    setRedirectUrl: (newValue: string | number | null | undefined) => void;
  }
>;

export function useRedirectUrl(): UseRedirectUrlReturn<string | null>;
export function useRedirectUrl<T>(defaultValue: T): UseRedirectUrlReturn<string | T>;

export function useRedirectUrl<T>(defaultUrl?: T): UseRedirectUrlReturn<string | T | null> {
  const params = useParams<"redirect_url" | (string & {})>();

  const redirectUrl = doIt(() => {
    const redirectUrl = params.get("redirect_url");
    if (defaultUrl !== undefined) return redirectUrl ?? defaultUrl;
    return redirectUrl;
  });

  const get = useCallback(() => {
    return redirectUrl;
  }, [redirectUrl]);

  const set = useCallback(
    (newValue: string | number | null | undefined) => {
      return params.set("redirect_url", newValue);
    },
    [params],
  );

  return { ...params, getRedirectUrl: get, setRedirectUrl: set };
}
